var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dc98450128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.546875 0 L 64.546875 0 L 64.546875 75 L 10.546875 75 Z M 10.546875 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc98450128)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M 64.515625 19.078125 C 64.515625 8.699219 56.089844 0.289062 45.691406 0.289062 C 40.417969 0.289062 34.632812 0.289062 29.359375 0.289062 C 18.964844 0.289062 10.535156 8.699219 10.535156 19.078125 C 10.535156 30.277344 10.535156 44.742188 10.535156 55.941406 C 10.535156 66.320312 18.964844 74.730469 29.359375 74.730469 C 34.632812 74.730469 40.417969 74.730469 45.691406 74.730469 C 56.089844 74.730469 64.515625 66.320312 64.515625 55.941406 C 64.515625 44.742188 64.515625 30.277344 64.515625 19.078125 Z M 62.023438 19.078125 C 62.023438 30.277344 62.023438 44.742188 62.023438 55.941406 C 62.023438 64.945312 54.710938 72.246094 45.691406 72.246094 C 40.417969 72.246094 34.632812 72.246094 29.359375 72.246094 C 20.339844 72.246094 13.027344 64.945312 13.027344 55.941406 C 13.027344 44.742188 13.027344 30.277344 13.027344 19.078125 C 13.027344 10.074219 20.339844 2.773438 29.359375 2.773438 C 34.632812 2.773438 40.417969 2.773438 45.691406 2.773438 C 54.710938 2.773438 62.023438 10.074219 62.023438 19.078125 Z M 62.023438 19.078125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M 43.921875 10.566406 L 31.132812 10.566406 L 31.132812 28.472656 L 43.921875 28.472656 Z M 33.621094 13.054688 L 33.621094 25.988281 L 41.429688 25.988281 L 41.429688 13.054688 Z M 33.621094 13.054688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M 36.28125 0.289062 L 38.769531 0.289062 L 38.769531 13.054688 L 36.28125 13.054688 Z M 36.28125 0.289062 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M 36.28125 25.988281 L 38.769531 25.988281 L 38.769531 41.324219 L 36.28125 41.324219 Z M 36.28125 25.988281 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicks);
export default __webpack_public_path__ + "static/media/clicks.9272d8389ca05c314e23717668b8310b.svg";
export { ForwardRef as ReactComponent };